import logoFc from "../../assets/Fondos2026/logo20262.png";
import useWindowSize from "../../hooks/sizeWindow";
import pulgar from "../../assets/iconos/microfono.png";
import logoMobile from "../../assets/PNG/fdlc_vRecurso.png";
// import logoFc2 from "../../assets/PNG/fdlc_vRecurso 3.png";
import logoFc2 from "../../assets/Fondos2026/logo20262.png";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import ModalReenviar from "../../components/ModalReenviar";

const Agotado = () => {
  const size = useWindowSize();
  const nav = useNavigate();

  // console.log(size.width)
  const [modalReenviar, setModalReenviar] = useState(false);
  const hide = () => setModalReenviar(false);

  return (
    <main className="bg2026V pb-5 ">
      <section className="  d-flex flex-column align-items-center pb-3 text-white   pt-5 " style={{ width: "100%", maxWidth: size.width < "500" ? "400px" : size.width < "700" ? "600px" : size.width < "1000" ? "700px" : "" }}>

        {
          size.width > "500"
            ?
            <img src={logoFc} alt="Logo-Fiesta-Confluencia" className="" style={{ width: "100%", maxWidth: size.width < "500" ? "400px" : size.width < "700" ? "500px" : "600px" }} />
            :
            <img src={logoFc2} alt="Logo-Fiesta-Confluencia" className="" style={{ width: "100%", maxWidth: size.width < "500" && "400px" }} />
        }

        <section className="d-flex flex-column align-items-center gap-4 " style={{ maxWidth: size.width < "500" ? "400px" : "500px" }}>


          <div className="d-flex flex-column gap-2 align-items-center">
            <p className={`${size.width > "500" ? "parrafoSM" : "parrafoXSM"} noSelect text-center  py-2 px-4 text-dark `} >
              Las entradas para buenos contribuyentes estan
            </p>
            <p className={`${size.width > "500" ? "parrafoSM" : "parrafoXSM"} noSelect text-center  py-2 px-4  text-WHITE bg-danger py-2 px-4`} style={{ transform: "rotate(-3deg)" }} >AGOTADAS</p>
          </div>

          <div className="d-flex flex-column gap-2 align-items-center">
            <p className={`${size.width > "500" ? "parrafSM" : "parrafoXSM"} noSelect  py-2 px-4 text-center`} style={{ color: "#111" }}>
              Podés comprar las entradas para tus shows favoritos a través de
            </p>
            <a href="https://entradauno.com/landing/14412-abono---fiesta-nacional-de-la-confluencia?idEspectaculoCartel=14412&cHashValidacion=dea9a7ba97137ef81315ac28caf86e4c9464833c" target="_black" style={{ backgroundColor: "#FFA000", color: "#FFF" }} className={`${size.width > "500" ? "parrafoXSM" : "parrafoXXSM"} py-1 px-2 rounded`} >EntradaUno</a>
          </div>

          {/* <button
            onClick={() => { nav('/') }}
            className={`px-4 py-2 ${size.width > "500" ? "parrafoXSM" : "parrafoXSM"} text-white mt-4 `}
            style={{
              backgroundColor: "#A349FF",
              border: "none",
            }}
          >
            VOLVER
          </button> */}


          <div className='pt-4  d-flex flex-column align-items-center gap-3 descripcion'>
            <p className='text-center px-4' style={{ color: "#853CCE" }}>Si no has recibido el email con sus códigos haga click en "Reenviar Email"
            </p>
            <button
              onClick={() => {
                setModalReenviar(true);
              }}
              type="submit"
              className={`enviar py-3 `}
              style={{ backgroundColor: "#52278A", color: "#FFF", boxShadow: "none", border: "none" }} >REENVIAR EMAIL</button>
          </div>

          {
            modalReenviar &&
            <ModalReenviar modalReenviar={modalReenviar} hide={hide} />
          }

          {/* <div className="d-flex  align-items-center gap-5 ">
    <p className={`${size.width > "500" ? "parrafoLG" : "parrafoSM"}  noSelect  w-100 px-4`}>
      Están excluidas de participar todas las personas que pertenezcan a la planta
      política del Municipio de la ciudad de Neuquén
    </p>
  </div> */}

          {/* <img style={{ width: size.width > "500" ? "250px" : "130px", zIndex: 1 }} className="mt-4" src={pulgar} alt="sol-icon" /> */}


        </section>
      </section>
    </main>
  );
};
export default Agotado;
